"use strict";

require("../modules/polyfill");

require("lazysizes/plugins/rias/ls.rias");

require("lazysizes/plugins/bgset/ls.bgset");

require("lazysizes");

require("lazysizes/plugins/respimg/ls.respimg");

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("../../styles/theme.scss");

require("../../styles/theme.scss.liquid");

var _header = require("../modules/header.js");

var header = _interopRequireWildcard(_header);

var _footer = require("../modules/footer.js");

var footer = _interopRequireWildcard(_footer);

var _video = require("../modules/video.js");

var video = _interopRequireWildcard(_video);

var _countries = require("../modules/countries.js");

var countries = _interopRequireWildcard(_countries);

require("what-input");

var _themeSections = require("@shopify/theme-sections");

require("../sections/newsletter-popup");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.load)('newsletter-popup');

// Accessibility library


header.init();
footer.init();
video.init();
countries.init();

(0, _jquery2.default)(".sliding-link").click(function (e) {
    e.preventDefault();
    var anchor = (0, _jquery2.default)(this).attr("href");
    (0, _jquery2.default)('html,body').animate({ scrollTop: (0, _jquery2.default)(anchor).offset().top - 50 }, 'slow');
});